import { locales } from './locales'
import { translationsVersion } from './translationsVersion'

function getCdnOrigin(variant: 'prod' | 'test'): string {
  if (
    typeof window !== 'undefined' &&
    window.location &&
    window.location.hostname &&
    (window.location.hostname.endsWith('.mil') ||
      window.location.hostname === 'exp.apps.dev.docusign.net')
  ) {
    return '/il5-cdn/global-cdn-assets/241848'
  }
  return variant === 'prod'
    ? 'https://docucdn-a.akamaihd.net'
    : 'https://docutest-a.akamaihd.net/241848'
}

export const cdnURLsPROD: Record<string, string> = {}

locales.forEach((locale) => {
  cdnURLsPROD[locale] = `${getCdnOrigin(
    'prod'
  )}/components/translations/${translationsVersion}/fes/${locale}.json`
})

export const cdnURLsTEST: Record<string, string> = {}

locales.forEach((locale) => {
  cdnURLsTEST[locale] = `${getCdnOrigin(
    'test'
  )}/components/translations/${translationsVersion}/fes/${locale}.json`
})
